import { Button, Col, Radio, Row, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import './index.css'
import { Link } from 'react-router-dom';
import { Colors } from '../../../../../config';
import { IoChevronBack } from 'react-icons/io5';
import { FaStripe } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQuery } from 'react-query';
import axiosInstance from '../../../../../config/api';
import { LoadingOutlined } from '@ant-design/icons';
import { FaExclamation } from "react-icons/fa";
import { setError, setMessage } from '../../../../../store/common/generalSlice';
import { fetchCards } from '../../../../../store/common/paymentSlice';
import Modal from '../../../../../components/Modal';
import PaymentCard from '../../../../../components/PayCard';
import ConnectWithStripe from '../../../../../assets/images/settings/ConnectWithStripe.png';

const StripeManagement = () => {

    const [mode, setMode] = useState('payment');
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState('')
    const { loggedInUser } = useSelector(state => state?.auth);
    const { loading, cards, error } = useSelector(state => state?.payments);

    const dispatch = useDispatch();

    useEffect(() => {
        if (mode == 'payment') {
            dispatch(fetchCards())
        }
    }, [mode])

    useEffect(() => {
        if (error) {
            dispatch(setError(error))
        }
    }, [error])

    // a case for SP only to get the wallet info.
    const getWallet = async () => {
        try {
            let res = await axiosInstance.get('/stripe/wallet');
            if (res?.status == 200) {
                return res?.data?.data?.wallet
            }
        } catch (error) {
            console.log(error)
            return
        }
    }

    // with enabled mode == account it will only run whenever the mode is account in case of SP.
    const { isLoading: walletLoading, data: walletData } = useQuery('getSpWallet', getWallet, {
        enabled: mode == 'account'
    })

    console.log(walletData)


    // stripe setup call.
    const stripeSetupMutation = useMutation(async () => {
        let res = await axiosInstance.post('/stripe/connected-account', {});
        return res
    },
        {
            onSuccess: (res) => {
                dispatch(setMessage(res?.data?.data?.message))
                window.open(res?.data?.data?.stripeLink?.url, '_blank')
            },
            onError: (error) => {
                dispatch(setError(error.response?.data?.message || 'An error occured'))
            }
        }
    )

    // stripe update mutation
    const stripeUpdateMutation = useMutation(async () => {
        let res = await axiosInstance.put(`/stripe/connected-account/${walletData?.accountId}`, {});
        return res
    },
        {
            onSuccess: (res) => {
                dispatch(setMessage(res?.data?.data?.message))
                window.open(res?.data?.data?.stripeLink?.url, '_blank')
            },
            onError: (error) => {
                dispatch(setError(error.response?.data?.message || 'An error occured'))
            }
        }
    )

    // delete card.
    const deleteCardMutation = useMutation(async (id) => {
        let res = await axiosInstance.delete(`/stripe/${id}/unlink-card`);
        return res
    },
        {
            onSuccess: (res) => {
                dispatch(setMessage(res?.data?.data?.message))
                dispatch(fetchCards())
                setDeleteModal(false)
            },
            onError: (error) => {
                dispatch(setError(error.response?.data?.message || 'An error occured'))
            }
        }
    )


    // stripe card add call.
    const cardAddMutation = useMutation(async () => {
        let res = await axiosInstance.post('/stripe/add-card', {});
        return res
    },
        {
            onSuccess: (res) => {
                dispatch(setMessage(res?.data?.data?.message))
                window.open(res?.data?.data?.cardCheckoutSession, '_blank')
            },
            onError: (error) => {
                dispatch(setError(error.response?.data?.message || 'An error occured'))
            }
        }
    )

    // a case of SP only the radio btns.
    const handleModeChange = (e) => {
        setMode(e.target.value);
    };

    // a case for SP only.
    const stripeAccountSetupHandler = async () => {
        if (!walletLoading && !walletData?.accountId) {
            !stripeSetupMutation?.isLoading && stripeSetupMutation.mutate()
        } else {
            dispatch(setMessage('Stripe account is already connected'))
        }
    }

    // a case for SP only.
    const stripeAccountUpdateHandler = async () => {
        if (!walletLoading) {
            stripeUpdateMutation.mutate()
        }
    }


    // card delete
    const cardDeleteHandler = (id) => {
        setDeleteId(id)
        setDeleteModal(true)
    }

    // on yes delete api caller
    const modalHandler = (action) => {
        if (!cardAddMutation?.isLoading) {
            if (action == 'yes') {
                deleteId && deleteCardMutation.mutate(deleteId)
            } else {
                setDeleteModal(false)
            }
        }
    }

    // card add caller
    const cardAddHandler = () => {
        if (!loading || !cardAddMutation?.isLoading) {
            cardAddMutation.mutate()
        }
    }

    return (
        <Row className='w-full flex flex-col gap-4 my-3'>
            {
                loggedInUser?.type == 'Service Provider' &&
                <Col span={24} className='flex items-center justify-between flex-wrap gap-4'>
                    <Radio.Group
                        onChange={handleModeChange}
                        size='middle'
                        value={mode}
                    >
                        <Radio.Button
                            className={mode == 'payment' ? 'selected-radio-btn' : 'unselected-radio-btn'}
                            value="payment">
                            Payment Account
                        </Radio.Button>

                        <Radio.Button
                            className={mode == 'account' ? 'selected-radio-btn' : 'unselected-radio-btn'}
                            value="account">
                            Pay-out Account
                        </Radio.Button>
                    </Radio.Group>
                    <Link to={'/settings'}>
                        <div className='w-fit flex items-center gap-2 cursor-pointer'>
                            <div className='rounded-full p-1 bg-white'>
                                <IoChevronBack color={Colors.AppYellow} />
                            </div>
                            <span>Back</span>
                        </div>
                    </Link>
                </Col>
            }

            <Col span={24} className='bg-white p-4'>
                {
                    loggedInUser?.type == 'Service Provider' && mode == 'account' ?
                        <div className='flex flex-col gap-3 items-start'>
                            <div className='flex gap-4 items-center'>
                                <div className='w-36 sm:w-48 flex items-center justify-center gap-3 bg-[#F3F3F9] cursor-pointer hover:scale-110 transition-all ease-in-out duration-200' onClick={stripeAccountSetupHandler}>
                                    {(walletLoading || stripeSetupMutation?.isLoading) && <Spin indicator={<LoadingOutlined />} size="default" />}
                                    {/* <FaStripe size={60} color='#635BFF' /> */}
                                    <img src={ConnectWithStripe} />
                                </div>
                                {
                                    walletData?.accountId &&
                                    <Button
                                        className={`bg-[${Colors.AppYellow}] h-16 py-5 w-fit text-md text-white custom-btn-gradient`}
                                        size='middle'
                                        iconPosition='end'
                                        onClick={stripeAccountUpdateHandler}
                                    >
                                        Update Stripe Account
                                    </Button>
                                }
                            </div>
                            {
                                !walletLoading && walletData?.accountId ?
                                    <div className='flex items-center gap-2 bg-[#02B563] text-white p-2 rounded-sm'>
                                        <div className='p-1 bg-white rounded-full'>
                                            <FaExclamation color='#02B563' />
                                        </div>
                                        <p>Account has been verified from stripe.</p>
                                    </div>
                                    :
                                    !walletLoading ?
                                        <div className='flex items-center gap-2 bg-[#f55e5e] text-white p-2 rounded-sm'>
                                            <div className='p-1 bg-white rounded-full'>
                                                <FaExclamation color='#f55e5e' />
                                            </div>
                                            <p>Account has not been verified from stripe.</p>
                                        </div>
                                        : ''
                            }
                            <div className='w-full'>
                                <h3 className='font-semibold text-base'>Note:</h3>
                                <p className='text-red-500 text-wrap'>
                                    The service provider's Stripe account and card are necessary for the payment of services being provided against the quotation so that the payment transaction proceeds smoothly and its record is maintained. Therefore, Mobrage is collecting these details.
                                </p>
                            </div>
                        </div>
                        :
                        mode == 'payment' ?
                            <div className='flex items-center gap-5 justify-start flex-wrap'>
                                <div className='flex items-center gap-4 flex-wrap'>
                                    {
                                        loading ?
                                            <Spin indicator={<LoadingOutlined />} size="large" />
                                            :
                                            cards?.length > 0 ?
                                                cards.map((card) => {
                                                    return (
                                                        <PaymentCard
                                                            card={card}
                                                            isDeleteCard={true}
                                                            cardDeleteHandler={cardDeleteHandler}
                                                        />
                                                    )
                                                })
                                                :
                                                <p>No cards available</p>
                                    }
                                </div>
                                <div className='p-4 bg-[#F4F4FA] text-[black] cursor-pointer flex gap-3 hover:scale-110 transition-all ease-in-out duration-200' onClick={cardAddHandler}>
                                    {
                                        cardAddMutation?.isLoading &&
                                        <Spin indicator={<LoadingOutlined />} size="default" />
                                    }
                                    Add a card
                                </div>

                                <div className='w-full'>
                                    <h3 className='font-semibold text-base'>Note:</h3>
                                    <p className='text-red-500 text-wrap'>
                                        {
                                            loggedInUser?.type == 'Service Provider' ?
                                                "The service provider's Stripe account and card are necessary for the payment of services being provided against the quotation so that the payment transaction proceeds smoothly and its record is maintained. Therefore, Mobrage is collecting these details."
                                                :
                                                "The job you are creating will be quoted by service providers, and you will pay for the one you accept using your card. We are taking the card for this purpose."
                                        }
                                    </p>
                                </div>
                            </div>
                            : ''
                }

            </Col>
            {
                <Modal.Confirmation
                    title={""}
                    open={deleteModal}
                    closeable={false}
                    width={280}
                    heading={"Are you sure you want to export?"}
                    isShowSaveButton={true}
                    className={'payment-confirmation-modal'}
                >
                    <Row className='w-full m-0 p-0 gap-0'>
                        <h2 className='text-center font-semibold mx-auto p-4 my-2'>Are you sure you want to delete card?</h2>
                        <div className='flex w-full action-btns'>
                            <Button loading={deleteCardMutation.isLoading} className='flex-1 rounded-bl-md bg-[#FAB700] text-black py-2 h-auto' onClick={() => modalHandler('yes')}>Yes</Button>
                            <Button className='flex-1 rounded-br-md bg-[#000000] text-white py-2 h-auto' onClick={() => modalHandler('no')}>No</Button>
                        </div>
                    </Row>
                </Modal.Confirmation>
            }
        </Row>
    )
}

export default StripeManagement